import { isValid, parse } from 'date-fns';

import { monthPlusDayOfMonthFormat } from './formats';
import { type NextAvailability } from './nextAvailability';

export const formatNextAvailability = (
  t: (key?: string, _?: Record<string, unknown>) => string,
  nextAvailability?: NextAvailability,
  defaultTranslationKey?: string
): string | undefined =>
  nextAvailability &&
  t(defaultTranslationKey, {
    formattedDate: isValid(
      parse(
        nextAvailability.formattedDateOrKey,
        monthPlusDayOfMonthFormat,
        new Date()
      )
    )
      ? nextAvailability.formattedDateOrKey
      : t(nextAvailability.formattedDateOrKey),
    formattedTime: nextAvailability.formattedTime,
  });
